exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link[data-v-8707b0b4] {\n  transition: 0.25s;\n}\n.nav-link[data-v-8707b0b4]:hover {\n  color: #fff !important;\n}", ""]);

// exports
